namespace appn.views.apiExplorer.index {

    class InitArgs {
        providerId: string = appn.emptyGuid;
        integrationKey: string = appn.emptyString;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        (window as any).swaggerUi = new (window as any).SwaggerUi({
            url: '../api/resources',
            dom_id: 'swagger-ui-container',
            supportedSubmitMethods: ['get', 'post', 'put', 'delete'],
            onComplete: function(swaggerApi: any, swaggerUi: any) {
                $('pre code').each(function(i, e) {
                    (window as any).hljs.highlightBlock(e);
                });
                $('input[name="CompanyId"]').val(_initArgs.providerId);
                $('input[name="VendorId"]').val(_initArgs.providerId);
                $('input[name="IntegrationKey"]').val(_initArgs.integrationKey);
            },
            onFailure: function() {
                console.log('Unable to Load SwaggerUI');
            },
            docExpansion: 'none'
        });

        (window as any).swaggerUi.load();
    }
}

// Satisfy typing errors with bare minimum defn
declare class SwaggerUi {
    constructor(obj: any);
}
declare namespace SwaggerClient {
    export class ApiKeyAuthorization {
        constructor(name: any, value: any, type: any);
    }
}
